module.exports = __webpack_public_path__ + "static/media/EX_CHATBOT.e66ecd06.png";